﻿import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

type LoadingIndicatorProps = {
    value: number;
};

function UploadIndicator({ value }: LoadingIndicatorProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', padding: '16px 8px' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress
                    aria-label="Film download progress"
                    variant="determinate"
                    value={value * 100}
                />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: '14px' }}
                >{`${Math.round(value * 100)}%`}</Typography>
            </Box>
        </Box>
    );
}

export default UploadIndicator;